/* jpcx1, J'ador Paris cart offer, personalized inside the cart. Any cart shows the Solene necklace.
   A cart that already holds Solene shows the Elise ring. A cart holding both shows nothing.
   The card markup (.imx) is a Custom block in the Essential Cart Drawer app, shared by every theme.
   layout/theme.liquid sets window.__imx before the app runs, so the app's own Bond Bracelet script stops
   and hands over to this file. Only a theme that loads this file shows these offers.
   Sends the same line properties as the product pages (snippets/jpms2.liquid). */
(function () {
  'use strict';

  var EYE = 'One more with meaning';
  var NAME_MAX = 9;
  var CDN = 'https://cdn.shopify.com/s/files/1/0672/0012/2932/files/';
  var GEMS = (document.currentScript ? document.currentScript.src : '').replace(/jpcx1\.js.*$/, 'jpms1-gems.webp');
  var OFFERS = [
    {
      handle: 'solene-birthstone-necklace',
      hook: 'A name in flowing script, with a birthstone for the month.',
      chain: true,
      pear: true,
      months: [
        ['January', 'Garnet color', '#9c1c2b', '01-january-garnet'],
        ['February', 'Amethyst color', '#6b3fa0', '02-february-amethyst'],
        ['March', 'Aquamarine color', '#4f94b5', '03-march-aquamarine'],
        ['April', 'Diamond color', '#74767a', '04-april-diamond'],
        ['May', 'Emerald color', '#1f8a5a', '05-may-emerald'],
        ['June', 'Alexandrite color', '#8b74b8', '06-june-alexandrite'],
        ['July', 'Ruby color', '#c4174f', '07-july-ruby'],
        ['August', 'Peridot color', '#7f9c1e', '08-august-peridot'],
        ['September', 'Sapphire color', '#1f45a8', '09-september-sapphire'],
        ['October', 'Pink Tourmaline color', '#c9698f', '10-october-pink-tourmaline'],
        ['November', 'Citrine color', '#c98a12', '11-november-citrine'],
        ['December', 'Blue Zircon color', '#1e86bd', '12-december-blue-zircon']
      ]
    },
    {
      handle: 'elise-birthstone-ring',
      hook: 'A name in script, a round birthstone, and no ring size to guess.',
      chain: false,
      pear: false,
      months: [
        ['January', 'Garnet color', '#9c1c2b'],
        ['February', 'Amethyst color', '#6b3fa0'],
        ['March', 'Aquamarine color', '#2f7f9f'],
        ['April', 'Diamond color', '#74767a'],
        ['May', 'Emerald color', '#1f8a5a'],
        ['June', 'Alexandrite color', '#7a62aa'],
        ['July', 'Ruby color', '#c4174f'],
        ['August', 'Peridot color', '#6a8418'],
        ['September', 'Sapphire color', '#1f45a8'],
        ['October', 'Pink Tourmaline color', '#b4527c'],
        ['November', 'Citrine color', '#a8730c'],
        ['December', 'Tanzanite color', '#3d3fb5']
      ]
    }
  ];
  var CHAINS = [['14', '35'], ['16', '40'], ['18', '45']];
  var METALS = {
    'Gold': 'radial-gradient(circle at 32% 28%,#FFF4CC 0%,#F2D47A 22%,#D4A63A 52%,#A9781E 78%,#7D5713 100%)',
    'Silver': 'radial-gradient(circle at 32% 28%,#FFFFFF 0%,#EDEFF1 24%,#C9CCD0 54%,#9DA1A7 80%,#7C8086 100%)',
    'Rose Gold': 'radial-gradient(circle at 32% 28%,#FFF0EA 0%,#F2C9B8 22%,#D29A86 52%,#AE6F5C 78%,#84503F 100%)'
  };
  var CHEV = '<svg class="jpcx-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var TICK = '<svg class="jpcx-tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  /* Shared by every copy of the card, so a drawer re-render keeps what was typed. */
  var st = { metal: '', month: -1, chain: 2, name: '', open: false, errStone: false, errName: false, msg: '', adding: false };
  var offer = null, product = null, show = null, curr = 'USD', busy = false, again = false, prods = {};

  function url(p) {
    var r = '/';
    try { if (window.Shopify && Shopify.routes && Shopify.routes.root) r = Shopify.routes.root; } catch (e) {}
    return r + p;
  }
  function fmt(c) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: curr, currencyDisplay: 'narrowSymbol' }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' ' + curr; }
  }
  function live() {
    return ((product && product.variants) || []).filter(function (v) { return v.available; });
  }
  function variant() {
    var l = live(), i;
    for (i = 0; i < l.length; i++) { if (l[i].option1 === st.metal) return l[i]; }
    return null;
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function gem(i, empty) {
    var cls = 'jpcx-g' + (empty ? ' is-empty' : '');
    if (offer.pear) return '<img class="' + cls + '" src="' + CDN + offer.months[i][3] + '-pear-96x96.webp" alt="" width="96" height="96" loading="lazy" decoding="async">';
    return '<span class="' + cls + ' jpcx-gs" style="--x:' + (i % 4) + ';--y:' + Math.floor(i / 4) + '"></span>';
  }

  function build(el) {
    var opts = offer.months.map(function (m, i) {
      return '<button type="button" class="jpcx-opt" role="option" data-month="' + i + '" style="--c:' + m[2] + '">' +
        gem(i) +
        '<span class="jpcx-t"><span class="jpcx-m">' + m[0] + '</span><span class="jpcx-s">' + m[1] + '</span></span>' + TICK + '</button>';
    }).join('');
    var metals = ((product.options && product.options[0] && product.options[0].values) || []).map(function (v) {
      return '<button type="button" class="jpcx-sw" data-metal="' + esc(v) + '" aria-label="' + esc(v) + '" style="--m:' + (METALS[v] || '#ccc') + '"></button>';
    }).join('');
    var chains = CHAINS.map(function (c, i) {
      return '<button type="button" class="jpcx-chip" data-chain="' + i + '">' + c[0] + ' in</button>';
    }).join('');
    el.querySelector('[data-imx-steps]').innerHTML =
      '<div class="jpcx-f"><p class="jpcx-l">Material <span data-jx="metal"></span></p><div class="jpcx-sws">' + metals + '</div></div>' +
      '<div class="jpcx-f" data-jx="stone"><p class="jpcx-l">Birthstone</p>' +
        '<button type="button" class="jpcx-trig" aria-haspopup="listbox" aria-expanded="false" aria-label="Choose birthstone">' +
          '<span class="jpcx-gw" data-jx="tg"></span>' +
          '<span class="jpcx-t"><span class="jpcx-m" data-jx="tm"></span><span class="jpcx-s" data-jx="ts"></span></span>' + CHEV + '</button>' +
        '<div class="jpcx-panel" role="listbox" aria-label="Birthstone">' + opts + '</div>' +
        '<p class="jpcx-err" role="alert">Please select a birthstone before adding to cart.</p></div>' +
      (offer.chain ? '<div class="jpcx-f"><p class="jpcx-l">Chain length <span data-jx="chain"></span></p><div class="jpcx-chips">' + chains + '</div></div>' : '') +
      '<div class="jpcx-f" data-jx="namebox"><label class="jpcx-l">Name<b>*</b><input class="jpcx-i" type="text" maxlength="' + NAME_MAX + '" placeholder="e.g. Emily" autocomplete="off" enterkeyhint="done"></label>' +
        '<p class="jpcx-err" role="alert">Please enter a name before adding to cart.</p></div>' +
      '<p class="jpcx-err jpcx-msg" role="alert"></p>';
    el.setAttribute('data-jx-built', offer.handle);
  }

  function draw(el) {
    el.__imx = 1;
    if (show !== true || !offer || !product || !live().length) { el.hidden = true; return; }
    if (!st.metal || !variant()) st.metal = live()[0].option1;
    if (el.getAttribute('data-jx-built') !== offer.handle) build(el);

    var q = function (s) { return el.querySelector(s); };
    var v = variant();
    var src = (v.featured_image && v.featured_image.src) || product.featured_image;
    var img = q('[data-imx-img]');
    if (img && src) {
      var next = (src.indexOf('//') === 0 ? 'https:' + src : src);
      next += (next.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      if (img.getAttribute('src') !== next) img.src = next;
      img.alt = product.title;
    }
    /* The photo and the title open the product page, on the variant chosen in the card. */
    var link = url('products/' + offer.handle) + '?variant=' + v.id;
    var nameBox = q('[data-imx-name]'), nameLink = nameBox.querySelector('a');
    if (!nameLink) {
      nameBox.textContent = '';
      nameLink = document.createElement('a');
      nameBox.appendChild(nameLink);
    }
    nameLink.href = link;
    nameLink.textContent = product.title;
    if (img) {
      var imgLink = img.parentNode;
      if (imgLink.tagName !== 'A') {
        imgLink = document.createElement('a');
        img.parentNode.insertBefore(imgLink, img);
        imgLink.appendChild(img);
      }
      imgLink.href = link;
      imgLink.setAttribute('aria-label', product.title);
    }
    q('[data-imx-eye]').textContent = EYE;
    q('[data-imx-hook]').textContent = offer.hook;
    q('[data-imx-from]').hidden = true;
    q('[data-imx-now]').textContent = fmt(v.price);
    var was = q('[data-imx-was]'), off = q('[data-imx-save]'), sale = v.compare_at_price > v.price;
    was.hidden = off.hidden = !sale;
    if (sale) {
      was.textContent = fmt(v.compare_at_price);
      off.textContent = Math.floor((1 - v.price / v.compare_at_price) * 100) + '% off';
    }

    q('[data-jx="metal"]').textContent = st.metal;
    [].forEach.call(el.querySelectorAll('.jpcx-sw'), function (b) {
      var name = b.getAttribute('data-metal');
      b.setAttribute('aria-pressed', name === st.metal ? 'true' : 'false');
      var ok = live().some(function (x) { return x.option1 === name; });
      b.disabled = !ok;
    });
    var stone = q('[data-jx="stone"]'), m = offer.months[st.month], tg = q('[data-jx="tg"]');
    stone.classList.toggle('is-open', st.open);
    stone.classList.toggle('is-invalid', st.errStone);
    q('.jpcx-trig').setAttribute('aria-expanded', st.open ? 'true' : 'false');
    q('[data-jx="tm"]').textContent = m ? m[0] : 'Select a month';
    q('[data-jx="ts"]').textContent = m ? m[1] : 'Choose the stone';
    q('.jpcx-trig').style.setProperty('--c', m ? m[2] : '#5A4C36');
    if (tg.getAttribute('data-k') !== String(st.month)) {
      tg.setAttribute('data-k', String(st.month));
      tg.innerHTML = gem(m ? st.month : 3, !m);
    }
    [].forEach.call(el.querySelectorAll('.jpcx-opt'), function (o) {
      o.setAttribute('aria-selected', Number(o.getAttribute('data-month')) === st.month ? 'true' : 'false');
    });
    if (offer.chain) q('[data-jx="chain"]').textContent = CHAINS[st.chain][0] + ' inches';
    [].forEach.call(el.querySelectorAll('.jpcx-chip'), function (c) {
      c.setAttribute('aria-pressed', Number(c.getAttribute('data-chain')) === st.chain ? 'true' : 'false');
    });
    var inp = q('.jpcx-i');
    if (inp.value !== st.name) inp.value = st.name;
    q('[data-jx="namebox"]').classList.toggle('is-invalid', st.errName);
    var msg = q('.jpcx-msg');
    msg.textContent = st.msg;
    msg.style.display = st.msg ? 'block' : 'none';
    var btn = q('[data-imx-btn]');
    btn.disabled = st.adding;
    btn.textContent = st.adding ? 'Adding' : 'Add it · ' + fmt(v.price);
    el.hidden = false;
  }
  function render() { [].forEach.call(document.querySelectorAll('.imx'), draw); }

  /* Which offer this cart gets: the first one not already in it that has stock. */
  function setOffer(o) {
    if (o !== offer) {
      offer = o;
      st.metal = ''; st.month = -1; st.chain = 2; st.name = ''; st.open = false;
      st.errStone = false; st.errName = false; st.msg = '';
    }
    product = o ? prods[o.handle] : null;
    show = !!o;
  }
  function load(h) {
    if (prods[h]) return Promise.resolve(prods[h]);
    return fetch(url('products/' + h + '.js')).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { prods[h] = p; return p; })
      .catch(function () { return null; });
  }
  function choose(list, i) {
    if (i >= list.length) { setOffer(null); return null; }
    return load(list[i].handle).then(function (p) {
      if (p && p.variants && p.variants.some(function (v) { return v.available; })) { setOffer(list[i]); return null; }
      return choose(list, i + 1);
    });
  }
  function check() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(url('cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
      curr = cart.currency || curr;
      var items = cart.items || [];
      return choose(items.length ? OFFERS.filter(function (o) {
        return !items.some(function (i) { return i.handle === o.handle; });
      }) : [], 0);
    }).catch(function () {}).then(function () {
      busy = false;
      render();
      if (again) { again = false; check(); }
    });
  }

  /* Scrolls only the drawer's own list, never the page behind it. */
  function reveal(node) {
    var p = node.parentElement;
    while (p && p !== document.body) {
      var o = getComputedStyle(p).overflowY;
      if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight) {
        p.scrollTo({ top: p.scrollTop + node.getBoundingClientRect().top - p.getBoundingClientRect().top - 12, behavior: 'smooth' });
        return;
      }
      p = p.parentElement;
    }
  }

  function add(el) {
    if (st.adding) return;
    var v = variant();
    if (!v) return;
    st.name = st.name.trim();
    st.errStone = st.month < 0;
    st.errName = !st.name;
    st.msg = '';
    if (st.errStone || st.errName) {
      if (st.errStone) st.open = true;
      render();
      reveal(el.querySelector(st.errStone ? '[data-jx="stone"]' : '[data-jx="namebox"]'));
      if (!st.errStone) el.querySelector('.jpcx-i').focus({ preventScroll: true });
      return;
    }
    var m = offer.months[st.month], c = CHAINS[st.chain];
    var props = { 'Birthstone': m[0] + ' (' + m[1] + ')', 'Name': st.name };
    if (offer.chain) { props['Chain length'] = c[0] + ' in'; props['_Chain cm'] = c[1] + ' cm'; }
    st.adding = true;
    render();
    fetch(url('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw 0;
      st.adding = false; st.month = -1; st.name = ''; st.open = false;
      show = false;
      render();
      ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change'].forEach(function (ev) {
        try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); window.dispatchEvent(new CustomEvent(ev)); } catch (e) {}
      });
      check();
    }).catch(function () {
      st.adding = false;
      st.msg = 'Something went wrong. Please try again.';
      render();
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('.imx');
    if (!el) {
      if (st.open) { st.open = false; render(); }
      if (t.closest('a[href*="/cart"], [aria-controls*="cart"], [class*="cart-toggle"], [data-cart-drawer]')) setTimeout(check, 60);
      return;
    }
    var b;
    if ((b = t.closest('.jpcx-sw'))) { st.metal = b.getAttribute('data-metal'); st.open = false; render(); return; }
    if (t.closest('.jpcx-trig')) { st.open = !st.open; render(); if (st.open) reveal(t.closest('.jpcx-f')); return; }
    if ((b = t.closest('.jpcx-opt'))) { st.month = Number(b.getAttribute('data-month')); st.open = false; st.errStone = false; render(); return; }
    if ((b = t.closest('.jpcx-chip'))) { st.chain = Number(b.getAttribute('data-chain')); st.open = false; render(); return; }
    if (t.closest('.imx-btn')) { add(el); return; }
    if (st.open && !t.closest('.jpcx-panel')) { st.open = false; render(); }
  }, true);
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('jpcx-i')) return;
    st.name = e.target.value;
    if (st.name.trim() && st.errName) { st.errName = false; render(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.classList || !e.target.classList.contains('jpcx-i')) return;
    e.preventDefault();
    e.target.blur();
  }, true);

  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      var list = document.querySelectorAll('.imx'), i, fresh = false;
      for (i = 0; i < list.length; i++) { if (!list[i].__imx) { fresh = true; break; } }
      if (!fresh) return;
      queued = true;
      setTimeout(function () { queued = false; render(); check(); }, 0);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change', 'cart:added', 'cart-drawer:open', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, check);
  });
  window.addEventListener('pageshow', check);

  /* The drawer app changes the cart without firing any theme event, so watch its requests. */
  var CART = /\/cart\/(add|change|update|clear)/;
  var ofetch = window.fetch;
  window.fetch = function (u) {
    var p = ofetch.apply(this, arguments);
    if (CART.test(String((u && u.url) || u))) p.then(function () { setTimeout(check, 50); }, function () {});
    return p;
  };
  var oopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (CART.test(String(u))) this.addEventListener('loadend', function () { setTimeout(check, 50); });
    return oopen.apply(this, arguments);
  };

  var css = document.createElement('style');
  css.textContent =
    '.imx [data-imx-steps]{margin-top:10px}' +
    '.imx .imx-hook{-webkit-line-clamp:2}' +
    '.imx .imx-thumb a{display:block;width:100%;height:100%}' +
    '.imx .imx-name a{color:inherit;text-decoration:none}.imx .imx-name a:focus-visible,.imx .imx-thumb a:focus-visible{outline:2px solid #B08D57;outline-offset:2px}@media (hover:hover){.imx .imx-name a:hover{text-decoration:underline;text-underline-offset:2px}}' +
    '.jpcx-f{margin-top:10px}.jpcx-f:first-child{margin-top:0}' +
    '.jpcx-l{display:block;margin:0 0 6px;font-size:12px;line-height:1.3;font-weight:700;color:#141414}' +
    '.jpcx-l span{font-weight:400;color:#4A4032;margin-left:3px}.jpcx-l b{color:#B23B3B}' +
    '.jpcx-sws{display:flex;gap:12px;padding:3px 3px 1px}' +
    '.jpcx-sw{appearance:none;-webkit-appearance:none;width:28px;height:28px;margin:0;padding:0;border:0;border-radius:50%;background:var(--m);cursor:pointer;box-shadow:inset 0 0 0 1px rgba(0,0,0,.1),0 1px 2px rgba(0,0,0,.16)}' +
    '.jpcx-sw[aria-pressed="true"]{box-shadow:inset 0 0 0 1px rgba(0,0,0,.1),0 0 0 2px #FDFAF4,0 0 0 3.5px #141414}' +
    '.jpcx-sw:disabled{opacity:.3;cursor:default}' +
    '.jpcx-trig{appearance:none;-webkit-appearance:none;width:100%;display:flex;align-items:center;gap:9px;margin:0;padding:5px 11px 5px 7px;border:1.5px solid #D9CFBE;border-radius:10px;background:#FFF;color:#141414;font:inherit;text-align:left;cursor:pointer}' +
    '.is-open>.jpcx-trig{border-color:#141414}.is-invalid>.jpcx-trig{border-color:#B23B3B}' +
    '.jpcx-g{display:block;flex:0 0 auto;width:30px;height:30px;object-fit:contain;mix-blend-mode:multiply}.jpcx-g.is-empty{opacity:.25}' +
    '.jpcx-gw{display:flex;flex:0 0 auto}' +
    '.jpcx-gs{border-radius:50%;background-image:url("' + GEMS + '");background-size:400% 300%;background-repeat:no-repeat;background-position:calc(var(--x) * 33.3333%) calc(var(--y) * 50%)}' +
    '.jpcx-t{display:block;flex:1 1 auto;min-width:0}' +
    '.jpcx-m{display:block;font-size:13px;line-height:1.2;font-weight:600;color:#141414}' +
    '.jpcx-s{display:block;margin-top:1px;font-size:11.5px;line-height:1.25;font-weight:600;color:var(--c,#5A4C36)}' +
    '.jpcx-chev{flex:0 0 auto;width:14px;height:14px;color:#4A4032;transition:transform .2s}.is-open .jpcx-chev{transform:rotate(180deg)}' +
    '.jpcx-panel{display:none;max-height:224px;overflow-y:auto;overscroll-behavior:contain;margin-top:5px;padding:4px;border:1px solid #D9CFBE;border-radius:10px;background:#FFF}.is-open>.jpcx-panel{display:block}' +
    '.jpcx-opt{appearance:none;-webkit-appearance:none;width:100%;display:flex;align-items:center;gap:9px;margin:0;padding:5px 8px;border:0;border-radius:8px;background:none;color:#141414;font:inherit;text-align:left;cursor:pointer}' +
    '.jpcx-opt[aria-selected="true"]{background:#FDF9F2}@media (hover:hover){.jpcx-opt:hover{background:#F7F3EC}}' +
    '.jpcx-tick{flex:0 0 auto;width:14px;height:14px;opacity:0}.jpcx-opt[aria-selected="true"] .jpcx-tick{opacity:1}' +
    '.jpcx-chips{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px}' +
    '.jpcx-chip{appearance:none;-webkit-appearance:none;min-height:36px;margin:0;padding:0;border:1.5px solid #D9CFBE;border-radius:10px;background:#FFF;color:#141414;font:inherit;font-size:12.5px;font-weight:600;cursor:pointer}' +
    '.jpcx-chip[aria-pressed="true"]{border-color:#141414;background:#FDF9F2;box-shadow:inset 0 0 0 .5px #141414}' +
    '.imx .jpcx-i{display:block;width:100%;height:40px;margin:6px 0 0;padding:0 11px;border:1.5px solid #D9CFBE;border-radius:10px;background:#FFF;color:#141414;font:inherit;font-size:16px;font-weight:400;box-shadow:none;outline:0}' +
    '.imx .jpcx-i:focus{border-color:#141414}.imx .jpcx-i::placeholder{color:#6B6055;opacity:1}.is-invalid .jpcx-i.jpcx-i{border-color:#B23B3B}' +
    '@media (min-width:750px){.imx .jpcx-i{font-size:14px}}' +
    '.jpcx-sw,.jpcx-trig,.jpcx-opt,.jpcx-chip,.imx .imx-btn{touch-action:manipulation;-webkit-tap-highlight-color:transparent}' +
    '@media (max-width:749px){.jpcx-panel{max-height:none;overflow:visible}.jpcx-sw{width:34px;height:34px}.jpcx-chip{min-height:44px;font-size:13.5px}.jpcx-trig{padding-top:7px;padding-bottom:7px}.jpcx-opt{padding-top:8px;padding-bottom:8px}.imx .jpcx-i{height:46px}.imx .imx-btn{padding-top:14px;padding-bottom:14px;font-size:14px}}' +
    '.jpcx-err{display:none;margin:6px 0 0;font-size:12px;line-height:1.35;font-weight:600;color:#B23B3B}.is-invalid>.jpcx-err{display:block}' +
    '.jpcx-trig:focus-visible,.jpcx-opt:focus-visible,.jpcx-chip:focus-visible,.jpcx-sw:focus-visible{outline:2px solid #B08D57;outline-offset:2px}';
  document.head.appendChild(css);

  window.__imx = { check: check, render: render };
  render();
  check();
})();
